// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"_ea-z"};